import { type MouseEvent, type ReactNode } from "react";
import { needsQuoteNotificationAccountSwitch, switchQuoteNotificationAccount } from "./quoteNotificationNavigation";
import { getQuoteDetailsUrl, type QuoteNotificationUrlData } from "./quoteNotificationUrl";

interface Props {
  children: ReactNode;
  data: QuoteNotificationUrlData;
  markAsRead: () => void;
}

export function QuoteNotificationLink({ children, data, markAsRead }: Props) {
  const detailsUrl = getQuoteDetailsUrl(data);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    markAsRead();

    if (!needsQuoteNotificationAccountSwitch(data)) {
      return;
    }

    event.preventDefault();
    void switchQuoteNotificationAccount(data, detailsUrl);
  };

  return (
    <a href={detailsUrl} onClick={handleClick}>
      {children}
    </a>
  );
}
